import React, { useState, useEffect } from 'react';

import { Container, ThisLi, ThisCol, ThisCirculo, ThisCard, ThisCardColor, ScrollOS, Container2, BodyColuna2, ThisCard2, ThisCardProj2, ThisCardColor2, ThisProgress2 } from './styles';
import api from '~/services/api';

import IconGroup from '~/assets/icones/IconGroup.svg';
import IconMax from '~/assets/icones/IconMax.svg';
import IconData from '~/assets/icones/IconData.svg';

function CustomBodyContent({ 
  data,
  etapas,
  idEtapa,
  setIdEtapa,
  tipoVisual
}) {
  const [linhaAtiva, setLinhaAtiva] = useState([]);
  const [lista, setLista] = useState([]);
  const [etapaColuna, setEtapaColuna] = useState([]);
  const [projetos, setProjetos] = useState(data);
  const [heightColBody, setHeightColBody] = useState(0);

  useEffect(() => {
    if (etapas?.length > 0) {
      let lista = [];

      for (const itemEtapa of etapas) {
        let quantAberto = 0;
        let listAberto = [];
        let quantProxVenc = 0;
        let listProxVenc = [];
        let quantVencido = 0;
        let listVencido = [];

        let listaData = [];

        let dataAtual = new Date();
        for (const itemData of data) {
          if (itemData?.idEtapa == itemEtapa?.id) {
            let findItem = itemData?.etapas?.find((e) => e?.idEtapa == itemData?.idEtapa);
            if (findItem) {
              let dataEtapa = new Date(findItem?.dataPrevEntrega);

              const second = 1000;
              const minute = second * 60;
              const hour = minute * 60;
              const day = hour * 24;

              let diff = Math.floor((dataAtual.getTime() - dataEtapa.getTime()) / day);
              
              if (diff > 0) {
                quantVencido++;
                listVencido.push(itemData);
              } else if(diff > -1) {
                quantProxVenc++;
                listProxVenc.push(itemData);
              } else {
                quantAberto++;
                listAberto.push(itemData);
              }
            } else {
              quantAberto++;
              listAberto.push(itemData);
            }
            
            listaData.push(itemData);
          }
        }

        lista.push({
          id: itemEtapa?.id,
          titulo: itemEtapa?.titulo,
          posicao: itemEtapa?.posicao,
          quantVencido,
          quantProxVenc,
          quantAberto,
          abertoVencido: true,
          abertoProxVenc: true,
          abertoAberto: true,
          listAberto,
          listProxVenc,
          listVencido,
          listaData,
        });
      }

      setEtapaColuna(lista);
    }
  }, [etapas, data]);

  useEffect(() => {
    setProjetos(data);
  }, [data]);

  return tipoVisual == "1" ? (
    <Container>
      <div className="content-oc">
        <ScrollOS>
          <div className="display-oc">
            {etapaColuna?.map((thisEtapa, i) => (
              <ThisCol key={thisEtapa?.id || i} id={thisEtapa?.id || i} index={i}>
                <div className="list-header">
                  <p className="titulo">{thisEtapa?.titulo}</p>
                  <div className="status">
                    <ThisCirculo 
                      className="vermelho"
                      ativo={thisEtapa.abertoVencido}
                      onClick={() => {
                        setEtapaColuna((prev) => {
                          let newPrev = [...prev];
    
                          newPrev[i].abertoVencido = !newPrev[i].abertoVencido;

                          return newPrev;
                        });
                      }}
                    >
                      <p>{thisEtapa?.quantVencido}</p>
                    </ThisCirculo>
                    <ThisCirculo 
                      className="amarelo"
                      ativo={thisEtapa.abertoProxVenc}
                      onClick={() => {
                        setEtapaColuna((prev) => {
                          let newPrev = [...prev];
    
                          newPrev[i].abertoProxVenc = !newPrev[i].abertoProxVenc;

                          return newPrev;
                        });
                      }}
                    >
                      <p>{thisEtapa?.quantProxVenc}</p>
                    </ThisCirculo>
                    <ThisCirculo 
                      className="verde"
                      ativo={thisEtapa.abertoAberto}
                      onClick={() => {
                        setEtapaColuna((prev) => {
                          let newPrev = [...prev];
    
                          newPrev[i].abertoAberto = !newPrev[i].abertoAberto;

                          return newPrev;
                        });
                      }}
                    >
                      <p>{thisEtapa?.quantAberto}</p>
                    </ThisCirculo>
                  </div>
                </div>
                <div className="list-body">
                  {thisEtapa?.abertoVencido && thisEtapa?.listVencido?.map(
                    (thisData, i) =>
                      thisData?.idEtapa == thisEtapa?.id && (
                        <ThisCard
                          className={
                            linhaAtiva === thisData?.id
                              ? 'card-item ativo'
                              : 'card-item'
                          }
                          {...{ data: thisData, linhaAtiva, setLinhaAtiva }}
                          key={thisData?.id || i}
                          id={thisData?.id || i}
                          index={i}
                          ativo={linhaAtiva === thisData?.id ? true : false}
                        >
                          <div className="card-header">
                            <div className="card-header-top">
                              <p className="codigo">#{thisData?.codigo}</p>
                              <div className="card-header-priori">
                                <ThisCardColor cor={"B33939"} />
                                {/* <p className="titulo">
                                  {thisData?.prioridade?.titulo}
                                </p> */}
                              </div>
                              {/* <p className="data">{((new Date(thisData?.dataProjeto).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0]}</p> */}
                            </div>
                            <p className="titulo">{thisData?.titulo}</p>
                            <p className="cliente">
                              {thisData?.cliente?.nomeFantasia}
                            </p>
                          </div>
                          <div className="card-footer">
                            <ul>
                              {
                                thisData?.atividades?.map((thisLi) => (
                                  <ThisLi key={thisLi?.id} entregue={thisLi?.dataEntrega != "" && thisLi?.dataEntrega != undefined}>
                                    {thisLi?.titulo}
                                  </ThisLi>
                                ))
                              }
                            </ul>
                          </div>
                        </ThisCard>
                      ),
                  )}
                  {thisEtapa?.abertoProxVenc && thisEtapa?.listProxVenc?.map(
                    (thisData, i) =>
                      thisData?.idEtapa == thisEtapa?.id && (
                        <ThisCard
                          className={
                            linhaAtiva === thisData?.id
                              ? 'card-item ativo'
                              : 'card-item'
                          }
                          {...{ data: thisData, linhaAtiva, setLinhaAtiva }}
                          key={thisData?.id || i}
                          id={thisData?.id || i}
                          index={i}
                          ativo={linhaAtiva === thisData?.id ? true : false}
                        >
                          <div className="card-header">
                            <div className="card-header-top">
                              <p className="codigo">#{thisData?.codigo}</p>
                              <div className="card-header-priori">
                                <ThisCardColor cor={"CCB32F"} />
                                {/* <p className="titulo">
                                  {thisData?.prioridade?.titulo}
                                </p> */}
                              </div>
                              {/* <p className="data">{((new Date(thisData?.dataProjeto).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0]}</p> */}
                            </div>
                            <p className="titulo">{thisData?.titulo}</p>
                            <p className="cliente">
                              {thisData?.cliente?.nomeFantasia}
                            </p>
                          </div>
                          <div className="card-footer">
                            <ul>
                              {
                                thisData?.atividades?.map((thisLi) => (
                                  <ThisLi key={thisLi?.id} entregue={thisLi?.dataEntrega != "" && thisLi?.dataEntrega != undefined}>
                                    {thisLi?.titulo}
                                  </ThisLi>
                                ))
                              }
                            </ul>
                          </div>
                        </ThisCard>
                      ),
                  )}
                  {thisEtapa?.abertoAberto && thisEtapa?.listAberto?.map(
                    (thisData, i) =>
                      thisData?.idEtapa == thisEtapa?.id && (
                        <ThisCard
                          className={
                            linhaAtiva === thisData?.id
                              ? 'card-item ativo'
                              : 'card-item'
                          }
                          {...{ data: thisData, linhaAtiva, setLinhaAtiva }}
                          key={thisData?.id || i}
                          id={thisData?.id || i}
                          index={i}
                          ativo={linhaAtiva === thisData?.id ? true : false}
                        >
                          <div className="card-header">
                            <div className="card-header-top">
                              <p className="codigo">#{thisData?.codigo}</p>
                              <div className="card-header-priori">
                                <ThisCardColor cor={"339C89"} />
                                {/* <p className="titulo">
                                  {thisData?.prioridade?.titulo}
                                </p> */}
                              </div>
                              {/* <p className="data">{((new Date(thisData?.dataProjeto).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0]}</p> */}
                            </div>
                            <p className="titulo">{thisData?.titulo}</p>
                            <p className="cliente">
                              {thisData?.cliente?.nomeFantasia}
                            </p>
                          </div>
                          <div className="card-footer">
                            <ul>
                              {
                                thisData?.atividades?.map((thisLi) => (
                                  <ThisLi key={thisLi?.id} entregue={thisLi?.dataEntrega != "" && thisLi?.dataEntrega != undefined}>
                                    {thisLi?.titulo}
                                  </ThisLi>
                                ))
                              }
                            </ul>
                          </div>
                        </ThisCard>
                      ),
                  )}
                </div>
              </ThisCol>
            ))}
          </div>
        </ScrollOS>
      </div>
    </Container>
  ) : (
    <Container2>
      <div className='content-projetos'>
        <div className='body'>
          <BodyColuna2 className='body-left' {...{ height: heightColBody + "em" }}>
            <div className='body-content'>
              {etapas?.map((thisData, a) => (
                <ThisCard2>
                  <div className={thisData?.id === idEtapa ? 'item ativo' : 'item'}
                    onClick={() => {
                      let dados = [];
                      for (const item of data) {
                        if (thisData?.id == item?.idEtapa) {
                          dados.push({ ...item });
                        }
                      }

                      setProjetos(dados);
                      setIdEtapa(thisData?.id);
                    }}
                  >
                    <div className="limite"></div>
                    <div className='item-colunas'>
                      <div className="item-col-quant">
                        <p className="quant">{}</p>
                      </div>
                      <div className='row-coluna'>
                        <p>{thisData?.titulo?.length > 50 ? thisData?.titulo?.substr(0, 50) + "..." : thisData?.titulo}</p>
                      </div>
                    </div>
                  </div>
                </ThisCard2>
              ))}
            </div>
          </BodyColuna2>
          <BodyColuna2 className='body-right' {...{ height: heightColBody + "em" }}>
            <div className='body-content'>
              <div className="content-right">
                {projetos?.map((thisData, i) => (
                  <ThisCardProj2
                    className={
                      linhaAtiva === thisData?.id
                        ? 'card-item ativo'
                        : 'card-item'
                    }
                    {...{ data: thisData, linhaAtiva, setLinhaAtiva }}
                    key={thisData?.id || i}
                    id={thisData?.id || i}
                    index={i}
                    ativo={linhaAtiva === thisData?.id ? true : false}
                  >
                    <div className="card-header">
                      <div className="card-header-top">
                        <p className="codigo">#{thisData?.codigo}</p>
                      </div>
                      <p className="titulo">{thisData?.titulo}</p>
                      <p className="cliente">
                        {thisData?.cliente?.nomeFantasia}
                      </p>
                    </div>
                    <div className="card-footer">
                      <div className='card-footer-top'>
                        <div className="content-progress">
                          <div className="card-content">
                            <p className="titulo">{thisData?.horaUsada}h/{thisData?.horaTotal}h</p>
                            <div className="progress">
                              <ThisProgress2 backgound="#34639C" width={((thisData?.horaUsada * 100) / thisData?.horaTotal) > 100 ? 100 : ((thisData?.horaUsada * 100) / thisData?.horaTotal) + "%"} />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='card-footer-bottom'>
                        <div className="card-footer-data">
                          <div className="fundo-img">
                            <img src={IconData} alt="IconData" />
                          </div>
                          <p className="data">
                            {"De " + ((new Date(thisData?.previsaoInicio).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0]}
                            {" Até " + ((new Date(thisData?.previsaoEntrega).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0]}
                          </p>
                        </div>
                        <div className="card-footer-priori">
                          <ThisCardColor2 cor={thisData?.prioridade?.cor} />
                          <p className="titulo">
                            {thisData?.prioridade?.titulo}
                          </p>
                        </div>
                      </div>
                    </div>
                  </ThisCardProj2>
                ))}
              </div>
            </div>
          </BodyColuna2>
        </div>
      </div>
    </Container2>
  );
}

export default CustomBodyContent;
